import React, { useState, useEffect, Component } from 'react'
import styled from 'styled-components'
import cn from 'classnames'
import Iconfont from '../Iconfont'

const SideMenu = styled.ul`
  background: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .isInIframe & {
    display: none;
  }

  & > li {
    font-size: 14px;
    letter-spacing: 0;
    margin-top: 20px;
    &:first-child {
      margin-top: 30px;
    }
    & > span {
      line-height: 38px;
      opacity: 0.4;
      display: inline-block;
      width: calc(100% - 20px);
      color: #17233d;
      border-bottom: 1px solid #b2becd;
      margin-left: 20px;
    }
  }
`

const SubMenu = styled.ul`
  background: #fff;
  list-style: none;
  font-size: 14px;
  color: #17233d;
  margin: 10px 0 0;
  padding: 0;
  li {
    position: relative;
    line-height: 38px;
    cursor: pointer;
    padding-left: 20px;
    & > a {
      color: #17233d;
      & > span {
        padding-left: 10px;
      }
    }
    &.active {
      background: #eaedf8;
      &:before {
        position: absolute;
        left: 0;
        top: 0;
        content: '';
        width: 4px;
        height: 100%;
        background-color: #4c79ff;
      }
    }
  }
`

export default (props) => {
  const {
    language,
    menus = [],
    formatMenuPath,
    changeRouter,
    selectedKey,
    onBeforeChange,
    onChange,
    onSelect,
  } = props
  const [activeMenu, setActiveMenu] = useState(selectedKey)
  const defaultBeforeChange = ({ data }) => !isNewTabMenu(data)
  const defaultSelect = ({ data }) => {
    const { path } = data || {}
    const formatPath = formatMenuPath || ((path) => path)

    if (isNewTabMenu(data)) {
      openInNewTab(formatPath(data?.path, data))
      return
    }

    const routerPrefix = window.location.pathname.match(/(^\/[^\/]+)/i)?.[1]

    if (window.location.pathname.startsWith(routerPrefix)) {
      const forwardPath = formatPath(path, data)
      changeRouter
        ? changeRouter(forwardPath, data)
        : window.history.pushState(data, data?.name, forwardPath)
    } else {
      window.location.href = formatPath(path, data)
    }
  }
  const selectMenu = (param = {}) => {
    const finalBeforeChange = onBeforeChange || defaultBeforeChange
    const finalSelect = onSelect || defaultSelect

    if (param.key !== activeMenu) {
      if (finalBeforeChange(param, activeMenu)) {
        setActiveMenu(param.key)
        onChange && onChange(param)
      }
    }

    finalSelect(param)
  }

  const MenuItem = ({ item }) => {
    const { code, groupName, enName, children = [] } = item
    const SubMenuItem = ({ menu }) => {
      const { code, menuName, enName, icon, path } = menu

      return (
        <li
          key={code}
          onClick={(evt) => selectMenu({ key: code, data: menu, domEvent: evt })}
          className={cn({ active: code === activeMenu })}
        >
          <a href={path} onClick={(evt) => evt.preventDefault()}>
            {icon instanceof Component ? icon : <Iconfont type={icon} />}
            <span>
              {
                {
                  cn: menuName,
                  en: enName,
                }[language]
              }
            </span>
          </a>
        </li>
      )
    }

    if (groupName && children.length) {
      return (
        <li key={code}>
          <span>
            {
              {
                cn: groupName,
                en: enName,
              }[language]
            }
          </span>
          <SubMenu>
            {children.map((subItem) => (
              <SubMenuItem menu={subItem} key={subItem?.code} />
            ))}
          </SubMenu>
        </li>
      )
    }

    return <SubMenuItem menu={item} />
  }

  useEffect(() => {
    setActiveMenu(selectedKey)
  }, [selectedKey])

  return (
    <SideMenu>
      {menus.map((menu) => (
        <MenuItem item={menu} key={menu.code} />
      ))}
    </SideMenu>
  )
}
